import React from 'react';
import ReactDOM from 'react-dom';
import Canvas from './image_generator/canvas';

function importImages(r) {
  let images = {};
  r.keys().map((item, index) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}

const images = importImages(
  require.context('./image_generator', false, /\.(png|jpe?g|svg)$/)
);

export default class ImageGenerator extends React.Component {
  constructor(props) {
    super(props);

    this.size = '1200x627'

    this.params = {
      square: [
        { value: 'true', title: 'Оквадратить' }
      ],
      logo: [
        { value: images['white_logo.png'], title: 'Белый лого' },
        { value: images['black_logo.png'], title: 'Черный лого' }
      ],
      textColor: [
        { value: 'white', title: 'Белый текст' },
        { value: 'black', title: 'Черный текст' }
      ],
      laurus: [
        { value: images['gold-laurus.png'],  title: 'Золотые лавры' },
        { value: images['green-laurus.png'], title: 'Зеленые лавры' }
      ]
    }

    this.presets = {
      news: {
        state: {
          background: null,
          backgroundX: 0,
          backgroundY: 0,
          backgroundDWidth: 0,
          textPosition: 'center',
          buttons: ['square', 'textColor', 'logo'],
          laurus: null
        },
        title: 'Новость'
      },
      award: {
        state: {
          background: images['gold-bg.jpg'],
          backgroundX: 0,
          backgroundY: 0,
          backgroundDWidth: 0,
          textPosition: 'center',
          buttons: ['square', 'textColor', 'logo'],
          laurus: null
        },
        title: 'Победа'
      },
      screening: {
        state: {
          background: images['green-bg.jpg'],
          backgroundX: 0,
          backgroundY: 0,
          backgroundDWidth: 0,
          textPosition: 'center',
          buttons: ['square', 'textColor', 'logo'],
          laurus: null
        },
        title: 'Участие'
      },
      laurus: {
        state: {
          background: null,
          backgroundX: 0,
          backgroundY: 0,
          backgroundDWidth: 0,
          textPosition: 'bottom',
          buttons: ['square', 'logo', 'laurus'],
          laurus: images['gold-laurus.png']
        },
        title: 'Участие/Победа'
      }
    }

    this.state = {
      logo: this.params.logo[0].value,
      text: '',
      textColor: this.params.textColor[0].value,
      textPosition: 'center',
      laurus: null,
      background: null,
      backgroundDWidth: 0,
      backgroundX: 0,
      backgroundY: 0,
      preset: 'news',
      buttons: ['square', 'textColor', 'logo']
    };
  }

  changeText = (event) => {
    this.setState({ text: event.target.value });
  }

  changeTextColor = (event) => {
    this.setState({ textColor: event.target.value });
  }

  changeSquare = (event) => {
    let value = this.state.square ? null : event.target.value;
    this.setState({ square: value });
  }

  changeBackgroundPosition = (event) => {
    if (!this.dragStart) return;

    event.preventDefault();
    event.persist();

    let $canvas = $(ReactDOM.findDOMNode(this.canvas)),
        width = this.size.split('x')[0],
        canvasScaleFactor = width / $canvas.width(),
        deltaX = event.pageX + this.startX,
        deltaY = event.pageY + this.startY;

    this.setState({
      backgroundX: deltaX * canvasScaleFactor,
      backgroundY: deltaY * canvasScaleFactor
    });
  }

  changeBackgroundScale = (event) => {
    event.preventDefault();
    event.persist();

    this.setState((prevState) => {
      return { backgroundDWidth: prevState.backgroundDWidth += event.deltaY };
    });
  }

  uploadBackground = (event) => {
    var target = event.target;
    if (!target.files || !target.files[0]) return;

    var reader = new FileReader();

    reader.onload = function (e) {
      this.setState({background: e.target.result});
    }.bind(this)

    reader.readAsDataURL(target.files[0]);
  }

  changeLogo = (event) => {
    let value = this.state.logo == event.target.value ? null : event.target.value;
    this.setState({ logo: value });
  }

  changeLaurus = (event) => {
    let value = this.state.laurus == event.target.value ? null : event.target.value;
    this.setState({ laurus: value });
  }

  download = (event) => {
    var canvas = ReactDOM
                 .findDOMNode(this.canvas)
                 .getElementsByTagName('canvas')[0];
    var dataURL = canvas.toDataURL('image/png');
    var fileName = 'pretty_image.png';
    if (dataURL.length*3/4 > 500000) {
      dataURL = canvas.toDataURL('image/jpeg');
      fileName = 'pretty_image.jpeg';
    }
    event.target.href = dataURL;
    event.target.download = fileName;
  }

  setPreset = (event) => {
    var presetName = event.target.value;
    var preset = this.presets[presetName];

    this.setState(Object.assign(preset.state, { preset: presetName }));
  }

  button(value, stateValue, title, className, key) {
    var active = value == stateValue ? 'active' : '';
    return (
      <span key={key}>
        <button className={'btn ' + className + ' ' + active}
                value={value}>
          {title}
        </button>{" "}
      </span>
    )
  }

  presetButtons() {
    return (
      <span onClick={this.setPreset}>
        {
          Object.keys(this.presets).map((preset, i) => {
            return this.button(preset,
                               this.state.preset,
                               this.presets[preset].title,
                               'btn-primary',
                               i);
          })
        }
      </span>
    )
  }

  buttons(param_name, key) {
    var changeFunctionName = 'change' +
                             param_name[0].toUpperCase() +
                             param_name.substring(1);

    return (
      <span onClick={this[changeFunctionName]} key={key}>
        {
          this.params[param_name].map((elm, i) => {
            return this.button(elm.value,
                               this.state[param_name],
                               elm.title,
                               'btn-filter',
                               i);
          })
        }
      </span>
    )
  }

  renderCanvas() {
    let [width, height] = this.size.split('x'),
        initialRatio = height/width,
        background = {
          src: this.state.background,
          dWidth: this.state.backgroundDWidth,
          x: this.state.backgroundX,
          y: this.state.backgroundY
        },
        paragraph = {
          text: this.state.text,
          position: this.state.textPosition,
          color: this.state.textColor
        },
        laurus = { src: this.state.laurus },
        logo = { src: this.state.logo };
    if (this.state.square) {
      if (width > height) { height = width } else { width = height }
    }
    return (
      <Canvas ref={(ref) => { this.canvas = ref; }}
              width={ width }
              height={ height }
              initialRatio = { initialRatio }
              background={ background }
              paragraph={ paragraph }
              laurus={ laurus }
              logo={ logo } />
    )
  }

  render() {
    return (
      <div className="top-space-lg form-horizontal">
        <div className="space-lg">
          {this.presetButtons()}
        </div>

        <div className="space-lg">
          <textarea className='form-control'
                    value={this.state.text}
                    onChange={this.changeText}
                    placeholder='Текст: только суть, коротко'>
          </textarea>
        </div>

        <div className="space-lg">
          <div className="file-input-wrapper btn-md">
            {'Загрузить изображение'}
            <input type="file" onChange={this.uploadBackground}/>
          </div>
        </div>

        <div className="space-lg">
          { this.state.buttons.map((b, i) => { return this.buttons(b, i) }) }
        </div>

        <div className="space-lg">
          <div style={{cursor: 'all-scroll'}}
               onWheel={this.changeBackgroundScale}
               onMouseMove={this.changeBackgroundPosition}
               onMouseDown={(e) => {
                 this.dragStart = true;
                 this.startX = this.state.backgroundX/2 - e.pageX;
                 this.startY = this.state.backgroundY/2 - e.pageY;
               }}
               onMouseUp={(e) => { this.dragStart = false}}>
            { this.renderCanvas() }
          </div>
          <small>можно таскать фон и растягивать скроллом</small>
        </div>

        <a className="btn btn-success"
           onClick={this.download}>
          Скачать
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/image_generator.jsx